import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TagProps } from "../types/attribute/tag";
import { api } from "../services/api.service";

export const fetchTags = createAsyncThunk<TagProps[]>("fetch/tags", async () => {
  const data = await api.attribute.tag.getAll();
  return data as TagProps[];
});

interface tagsState {
  tags: TagProps[];
  tag: null | TagProps;
  loading: boolean;
  error: null | string;
}

const initialState: tagsState = {
  tags: [],
  tag: null,
  loading: false,
  error: null,
};

export const tagsSlice = createSlice({
  name: "tags",
  initialState,
  reducers: {
    addTag: (state, action: PayloadAction<TagProps>) => {
      state.tags.push(action.payload);
    },
    removeTag: (state, action: PayloadAction<{ id: number }>) => {
      state.tags = state.tags.filter((tag) => tag.id !== action.payload.id);
    },
    updateTag: (state, action: PayloadAction<TagProps>) => {
      state.tags = state.tags.map((tag) =>
        tag.id === action.payload.id ? action.payload : tag
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTags.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.tags = action.payload;
      })
      .addCase(fetchTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export const { addTag, removeTag, updateTag } = tagsSlice.actions;

export default tagsSlice.reducer;
